<template>
    <div v-if="webConfig.notice" class="notice">
        <div class="words" style="color: #E6A23C">{{ webConfig.notice }}</div>
    </div>
<!--    <div v-if="!prod" class="absolute white-color bg-red-color z-10 right-0 bottom-0 px-10px py-2px">-->
<!--        <i class="fa fa-warning yellow-color"></i> 当前系统api服务为开发模式，如是生产环境请注意配置：spring.profiles.active=prod-->
<!--    </div>-->
    <Layout v-if="isManage==2" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed" class="app-frame">
        <Sider :theme="layoutConfig.siderTheme">
            <appMenu :theme="layoutConfig.siderTheme"></appMenu>
        </Sider>
        <Layout :headerFixed="layoutConfig.headerFixed">
            <HHeader theme="white">
                <appHead v-if="refreshAppHead" :layoutConfig="layoutConfig" :selectedTab="selectedTab"></appHead>
            </HHeader>
            <Content class="flex flex-column">
                <app-tabs/>
                <div class="app-frame-content flex1 p-14px" style="height: 0;overflow-y: auto;border:1px solid #BBBBBB;background: #FFFFFF;">
                    <template v-for="tab in tabs" :key="tab.key">
                        <Suspense>
                            <component is="ReportView" v-if="tab.key.startsWith('ReportView')" v-show="currentTab === tab.key"
                                       :dimension="tab.params.dimension" :reportId="tab.params.reportId"/>
                            <component :is="getKey(tab.key)" v-else v-show="currentTab === tab.key" v-bind="tab.props"/>
                            <!-- 加载中状态 -->
                            <template #fallback>
                                <div class="bg-white-color h-full flex justify-center items-center flex-column">
                                    <div class="mb-16px">
                                        <div class="loading">
                                            <div class="shape shape-1"></div>
                                            <div class="shape shape-2"></div>
                                            <div class="shape shape-3"></div>
                                            <div class="shape shape-4"></div>
                                        </div>
                                    </div>
                                    <div>页面加载中,请稍后...</div>
                                </div>
                            </template>
                        </Suspense>
                    </template>
                </div>
            </Content>
        </Layout>
    </Layout>
    <div v-if="isManage==1" class="layout-demo-2-vue">
        <Layout :headerFixed="true">
            <HHeader theme="dark" style="padding: 0 0 0 0px;">
                <div class="layout-logo">
                    <div style="width: 100px;float: left;margin-right: 20px;">
                        <appLogo></appLogo>
                    </div>
                    <div style="display: flex; align-items: center;">
                        <div style="width: 20px;float: left;">
                            <img :src="require('@/assets/qy2.png')">
                        </div>
                        <vxe-tooltip :content="User.companyName">
                            <vxe-text-ellipsis :content="User.companyName" style="font-size: 18px;color: #FFFFFF;"></vxe-text-ellipsis>
                        </vxe-tooltip>
                    </div>
                </div>
                <div style="float: left">&nbsp;&nbsp;|</div>
                <Menu ref="headMenu" :datas="headMenus" @select="headMenusTriggerSelect" mode="horizontal" className="menu-head-custom"
                      style="background-color: black;margin-top: 5px;width: 60%;float: left;"></Menu>
                <div style="width: 150px;height: 50px;float: right;margin-top: 5px;margin-right: 5px;">
                    <DropdownMenu className="app-header-dropdown" offset="0,0" :width="160" placement="bottom-end"
                                  :datas="infoMenu" @clickItem="trigger" trigger="hover">
                        <Avatar src="/images/yun.png" :width="30"><span>{{ User.realName }}</span></Avatar>
                    </DropdownMenu>
                </div>
            </HHeader>
            <Layout :siderCollapsed="false" :siderFixed="true">
                <Sider theme="white" v-if="headMenuSelect!='WorkIndex'">
                    <Menu ref="leftMenu" @select="leftMenuTriggerSelect" :datas="menuDatas" mode="vertical" className="h-menu-white" style="width: 200px;"></Menu>
                </Sider>
                <Content style="padding: 20px 20px;background-color: #ffffff;border-left: 1px solid #BBBBBB;">
                    <div style="background: rgb(255, 255, 255); min-height: 800px;">
                        <template v-for="tab in componentList" :key="tab.key">
                            <Suspense>
                                <Component :is="headMenuSelect" v-if="headMenuSelect == tab.key"/>
                                <!-- 加载中状态 -->
                                <template #fallback>
                                    <div class="bg-white-color h-full flex justify-center items-center flex-column">
                                        <div class="mb-16px">
                                            <div class="loading">
                                                <div class="shape shape-1"></div>
                                                <div class="shape shape-2"></div>
                                                <div class="shape shape-3"></div>
                                                <div class="shape shape-4"></div>
                                            </div>
                                        </div>
                                        <div>页面加载中,请稍后...</div>
                                    </div>
                                </template>
                            </Suspense>
                        </template>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>
<script>

import appHead from './app/app-header';
import appMenu from './app/app-menu';
import appFooter from './app/app-footer';
import appLogo from './app/app-logo';
import {mapGetters, mapMutations, mapState} from 'vuex';
import AppTabs from "@/views/app/app-tabs.vue";
import {message} from "heyui.ext";
import EventBus from "@/js/common/EventBus";
import common from "@api/common";
import {layer} from "@layui/layer-vue";
import {defineAsyncComponent, h} from "vue";

export default {
    name: "FXY",
    data() {
        return {
            selectedTab: "Home",
            refreshAppHead:true,
            isRouterAlive: true,
            layoutConfig: {
                siderTheme: 'dark',
                showSystab: false,
                headerFixed: true,
                siderFixed: true
            },
            year: new Date().getFullYear(),
            infoMenu: [
                {key: 'PersonalSetting', title: '账号信息', icon: 'h-icon-user', height: '430px'},
                {key: 'ChangePassword', title: '修改密码', icon: 'h-icon-lock', height: '430px'},
                // {key: 'ChangePhoneNumber', title: '账号变更', icon: 'h-icon-link', height: '430px'},
                {key: 'logout', title: '退出登录', icon: 'h-icon-outbox'}
            ],
            headMenuSelect:"WorkIndex",
            headMenus:[
                {title: '首页', key: 'WorkIndex', icon: 'h-icon-home'},
                {title: '财务', key: 'financialHead', icon: 'h-icon-calendar'},
                // {title: '审账', key: 'checkHead', icon: 'h-icon-task'},
            ],
            componentList:[
                {title: '首页', key: 'WorkIndex'},
                {title: '记账', key: 'AccountSetList'},
                {title: '查账', key: 'CheckAccountSets'},
                {title: '查账报告', key: 'CheckAccountReport'},
                {title: '财务进度', key: 'ProgressVoucher'},
                {title: '部门管理', key: 'Corp'},
                {title: '员工管理', key: 'CorpEmp'},
                // {title: '企业', key: 'Check'},
            ],
            financialMenus:[
                {
                    title: '财务处理',
                    key: 'financialHead',
                    icon: 'h-icon-calendar',
                    // count: 100,
                    children: [{title: '记账', key: 'AccountSetList'}]
                },
                {
                    title: '财务进度',
                    key: 'ProgressVoucher',
                    icon: 'h-icon-calendar',
                    // count: 100,
                },
                // {
                //   title: '查账',
                //   key: 'CheckAccountSets',
                //   icon: 'h-icon-calendar',
                //   // count: 100,
                // },
            ],
            checkMenus:[
                {
                    title: '企业',
                    key: 'Check',
                    icon: 'h-icon-calendar',
                    // count: 100,
                },
            ],
            deptMenus:[
                {
                    title: '部门及员工管理',
                    key: 'DeptAndEmp',
                    icon: 'h-icon-calendar',
                    // count: 100,
                    children: [{title: '部门管理', key: 'Corp'},{title: '员工管理', key: 'CorpEmp'}]
                },
            ],
            menuDatas: [],
            isManage: 1
        };
    },
    watch: {
        currentTab(val) {
            this.selectedTab = val;
            if (this.tabMap && this.tabMap[val] && !this.tabMap[val].ignoreCache) {
                localStorage.setItem(this.currentTabKey, JSON.stringify(this.tabMap[val]));
            }
            location.hash = val;
        },
        '$store.state.workbenchPage'(val) {
            if (val && val.key) {
                this.headMenuSelect = val.key;
            }
        },
        '$store.getters.checkoutList'(list) {
            this.refreshAppHead = false;
            this.$nextTick(() => {
                this.refreshAppHead = true;
            });
        }
    },
    methods: {
        ...mapMutations(['changeTab', 'newTab']),
        isShow() {
            return this.currentTab != 'SubjectBalance';
        },
        closeTab(key) {
            this.$store.commit('closeTab', key);
        },
        tabClick({key}) {
            if (this.currentTab !== key) {
                this.$store.commit('changeTab', key);
            }
        },
        getKey(key) {
            if (key.startsWith('ReportView')) {
                return "ReportView";
            }
            if (key.startsWith('VoucherForm')) {
                EventBus.off('f1-pressed');
                window.removeEventListener('keydown', this.handleGlobalKey);
                window.addEventListener('keydown', this.handleGlobalKey);
            } else {
                EventBus.off('f1-pressed');
                window.removeEventListener('keydown', this.handleGlobalKey);
            }
            return key.split(":")[0]
        },
        reportId(tab) {
            if (tab.key.startsWith('ReportView')) {
                return tab.params.reportId;
            }
            return null;
        },
        dimension(tab) {
            if (tab.key.startsWith('ReportView')) {
                return tab.params.dimension;
            }
            return null;
        },
        handleGlobalKey(event) {
            if ((event.key === 'F1' || event.key === 'F4' || event.key === '`' || event.key === 'PageUp' || event.key === 'PageDown')
                ||((event.ctrlKey || event.metaKey) && event.key === 's' )
                ||((event.ctrlKey || event.metaKey) && event.key === 'e' )
                ||((event.ctrlKey || event.metaKey) && event.key === 'q' )
                ||((event.ctrlKey || event.metaKey) && event.key === 'l' )) {
                event.preventDefault(); // 阻止浏览器默认帮助
                event.stopPropagation(); // 阻止事件冒泡
                EventBus.emit('f1-pressed', event); // 触发全局事件
            }
        },
        leftMenuTriggerSelect(menu){
            this.headMenuSelect = menu.key;
        },
        headMenusTriggerSelect(menu){
            console.log()
            const layout = document.querySelector('.h-layout.h-layout-sider-fixed');
            if(menu.key=='WorkIndex'){
                this.headMenuSelect = menu.key;
                layout.style.paddingLeft = '0';
            }else if(menu.key=='financialHead'){
                layout.style.paddingLeft = '200px';
                this.menuDatas = this.financialMenus;
                this.headMenuSelect = this.menuDatas[0].children[0].key;
                this.$nextTick(()=>{
                    this.$refs.leftMenu.select(this.headMenuSelect);
                })
            }else if(menu.key=='checkHead') {
                layout.style.paddingLeft = '200px';
                this.menuDatas = this.checkMenus;
                this.headMenuSelect = this.menuDatas[0].key;
                this.$nextTick(()=>{
                    this.$refs.leftMenu.select(this.headMenuSelect);
                })
            }
            // this.headMenuSelect = menu.key;
        },
        getAllParams() {
            const params = {};
            new URLSearchParams(window.location.search).forEach((value, key) => {
                params[key] = value;
            });
            return params;
        },
        trigger(data) {
            if (data === 'logout') {
                common.logout().then(() => {
                    window.location.replace("/");
                });
            }else if(data === 'DeptAndEmp'){
                const layout = document.querySelector('.h-layout.h-layout-sider-fixed');
                layout.style.paddingLeft = '200px';
                this.menuDatas = this.deptMenus;
                this.headMenuSelect = this.menuDatas[0].children[0].key;
                this.$nextTick(()=>{
                    this.$refs.leftMenu.select(this.headMenuSelect);
                    this.$refs.headMenu.select(null);
                })
            } else {
                const find = this.infoMenu.find(val => val.key === data);
                let layerId = layer.open({
                    title: find.title,
                    shadeClose: false,
                    zIndex: 999,
                    area: ['600px', find.height],
                    content: h(defineAsyncComponent(() => import('@/views/personal/' + data + '.vue')),{
                        onClose: () => {layer.close(layerId)},
                        onSuccess: () => {layer.close(layerId)}}
                    )
                });
            }
        },
    },
    computed: {
        ...mapState(['User','sliderCollapsed', 'tabs', 'currentTab', 'menus', 'webConfig', 'prod']),
        ...mapGetters(['tabMap', 'currentTabKey'])
    },
    components: {
        AppTabs,
        appHead,
        appMenu,
        appFooter,
        appLogo
    },
    created() {
        const queryParams = this.getAllParams();
        this.$nextTick(() => {
            if(queryParams.isManage==2){
                this.isManage = queryParams.isManage?queryParams.isManage:true;
                document.title = this.User.accountSets.companyName+'-乐智蜂代账软件';
            }else{
                // this.$refs.headMenu.select(this.headMenuSelect);
                // this.headMenusTriggerSelect(this.headMenus[0]);
                this.$refs.headMenu.select("financialHead");
                this.headMenusTriggerSelect(this.headMenus[1]);
                document.title = '乐智蜂代账软件-财务软件、云财务'
            }
        })
        if(this.User.admin==true){
            this.infoMenu.splice(0, 0, {key: 'DeptAndEmp', title: '部门及员工管理', icon: 'h-icon-users', height: '430px'});
        }
        // const currentTab = localStorage.getItem(this.currentTabKey)
        // if (currentTab) {
        //     this.newTab(JSON.parse(currentTab));
        // }
    },
    errorCaptured(args) {
        if (args.name === 'ChunkLoadError') {
            // alert('系统已更新，即将刷新页面...');
            window.location.reload();
            return false;
        } else {
            message.error(args.message);
            return true;
        }
    }
};
</script>
<style lang="less" scoped>
.h-icon-close-min {
    margin-left: 10px;
    font-weight: bold;

    &:hover {
        color: #f60 !important;
    }
}

.notice {
    width: 100vw;
    white-space: nowrap;
    overflow: hidden;
    height: 20px;
    position: fixed;
    left: 0;
    z-index: 1000;
    font-size: 12px;
    font-weight: bold;
}

.notice .words {
    position: absolute;
    display: inline-block;
    color: #ff6600;
    white-space: nowrap;
    animation: marquee 60s linear infinite;
}

.notice:hover .words {
    animation-play-state: paused;
}

@keyframes marquee {
    0% {
        left: 100%;
    }
    100% {
        left: 0%;
        transform: translateX(-100%);
    }
}
</style>
<style lang="less">
@menu-prefix: ~'@{prefix}menu';
.menu-head-custom {
    background: #fff;
    .@{menu-prefix} {
        &-li {
            &-selected {
                //border-bottom: 3px solid @blue-color;
                // 选中状态 - 蓝色从下往上渐变
                background: linear-gradient(to top, #3565F6,darken(#3565F6, 30%), #000) !important;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
        &-show {
            height: 50px;
            transition: font-size 0.1s, color 0.1s;
            &:hover {
                color: #FFFFFF;
            }
        }
    }
}
</style>
<style lang="less" scoped>
:deep(.h-menu-white .h-menu-li .h-menu-li-selected) {
    background-color: #FFFFFF;
}
:deep(.menu-head-custom) {
    .h-menu-show{
        padding: 15px 15px;
    }
    .h-menu-show .h-menu-show-desc {
        font-size: 18px;
    }
    .h-menu-show .h-menu-show-icon {
        font-size: 18px;
    }
}
:deep(.app-header-dropdown .h-dropdowncustom-show-content) {
    background: #000 !important;
}
:deep(.app-header-dropdown){
    padding: 0px;
}
.layout-demo-2-vue {
    .h-layout {
        background: #FFFFFF;
    }
    .layout-logo {
        max-width: 360px;
        //height: 31px;
        //background: rgba(255, 255, 255, 0.2);
        //margin: 16px 24px 16px 0;
        float: left;
    }
    .h-layout-header {
        padding: 0 50px;
    }
}
</style>
